// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-input[data-v-6e3ce8e1] .v-input__append-outer{margin-top:0!important;margin-bottom:0!important}", ""]);
// Exports
module.exports = exports;
